/* eslint-disable no-empty */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
} from '@angular/core';
import { AuthFacade } from '@ideapa/app-auth';
import { KeyboardFacade } from '@ideapa/app-keyboard';
import { NotificationsFacade } from '@ideapa/app/notifications';
import { StatoEvento } from '@ideapa/common-utils';

@Component({
  standalone: false,
  selector: 'ideapa-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent {
  loggedUser$ = this.authFacade.selectLoggedUser$;

  notificheInApp$ = this.notificationsFacade.items$;

  unreadCount$ = this.notificationsFacade.unreadCount$;

  @Input()
  hideNavbar = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private authFacade: AuthFacade,
    private keyboardFacade: KeyboardFacade,
    private notificationsFacade: NotificationsFacade
  ) {}

  get StatoNotifica() {
    return StatoEvento;
  }

  /**
   * Sidebar toggle on hamburger button click
   */
  toggleSidebar(e: Event) {
    e.preventDefault();
    this.document.body.classList.toggle('sidebar-open');
  }

  /**
   * Logout
   */
  onLogout(e: Event) {
    this.authFacade.logout();
  }

  changePassword(e: Event) {
    this.authFacade.showChangePasswordPopup();
  }

  refresh() {
    this.authFacade.forceRefresh();
  }

  showHelp() {
    this.keyboardFacade.showHelp(true);
  }
}
